var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"locale-select",attrs:{"aria-label":_vm.$t('client_page.language'),"data-testid":"locale-select"},domProps:{"value":_vm.currentLocale},on:{"change":_vm.changeLocale}},_vm._l((_vm.locales),function(locale){return _c('option',{key:locale.value,domProps:{"value":locale.value}},[_vm._v(" "+_vm._s(locale.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }